import type { MyPoll } from '@/lib/polls-api'

export type PollResultRow = {
  id: string
  label: string
  votes: number
  mine?: boolean
  // Admin view only: who added a participant option.
  author?: string | null
}

// Null while the results are not released to the current user.
export function getMyPollResultRows(poll: MyPoll): PollResultRow[] | null {
  if (poll.voter_count === null) return null
  return poll.options.map((option) => ({
    id: option.id,
    label: option.label,
    votes: option.vote_count ?? 0,
    mine: poll.my_option_ids.includes(option.id),
  }))
}
